module.exports = __webpack_public_path__ + "static/media/Simple-Line-Icons.b2892aa6.ttf";